import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { PreloaderRegistry } from '@bcf-vanilla-ts-v1-shared/misc/preload-store/run-preloaders';
import type { WorkerBlocRegistry } from '../common/types';
import type { WorkerBlocId } from '../worker-blocs.type';

/**
 * Per-app route-preloader registry, the parallel of WORKER_BLOCS_REGISTRY. Defaults to an empty
 * registry so every app that never registers one simply ignores every preloader id it is sent.
 */
// biome-ignore lint/style/useNamingConvention: must be that way
export const PRELOADERS_REGISTRY: DiToken<readonly PreloaderRegistry[]> = new DiToken<readonly PreloaderRegistry[]>(
  'preloadersRegistry',
  {
    factory: (): readonly PreloaderRegistry[] => []
  }
);

// biome-ignore lint/style/useNamingConvention: must be that way
export const WORKER_BLOCS_REGISTRY: DiToken<WorkerBlocRegistry[]> = new DiToken<WorkerBlocRegistry[]>(
  'workerBlocsRegistry'
);

// biome-ignore lint/style/useNamingConvention: must be that way
export const WORKER_BLOCS_REGISTRY_WHITELIST: DiToken<WorkerBlocId[]> = new DiToken<WorkerBlocId[]>(
  'workerBlocsRegistryWhitelist'
);

// biome-ignore lint/style/useNamingConvention: must be that way
export const IS_WORKER: DiToken<boolean> = new DiToken<boolean>('isWorker');

// biome-ignore lint/style/useNamingConvention: must be that way
export const WORKER_BLOC_LAZY_CHUNK_LOADED_HOOK: DiToken<(() => void) | undefined> = new DiToken<
  (() => void) | undefined
>('workerBlocLazyChunkLoadedHook');
